export default function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/[^a-z0-9]+/g, '-') // boşlukları tireye çevir
      .replace(/^-+|-+$/g, '');    // baştaki ve sondaki tireleri kaldır
  }
  